//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import VoucherCreateFormContainer from "./createFormContainer";
//#endregions
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateVoucherDialog(onCreateSuccess?: () => void): DialogProps {
  return {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Voucher.NewVoucher),
    titleIcon: IconDefinitionConstants.WDocument,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Voucher.Book),
        successMessage: TranslationKeys.Voucher.CreatedVoucher,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <VoucherCreateFormContainer />,
    maxWidth: "md",
    onSubmit: onCreateSuccess,
  };
}

export default useCreateVoucherDialog;
